import { Box, Typography, useTheme } from "@mui/material";
import { Image } from "@mui/icons-material";
import { ExtendedFormItemProperties } from "@sis/react-library";
import { ModalImageCropper } from "./ModalImageCropper";

interface ProfilePictureFormCoverImageProps<T> {
    profilePictureFile?: File,
    profilePictureUrl?: string,
    onProfilePictureChange: (file: File, fileName: string) => void;
    submitting: boolean;
    formItemProperties: ExtendedFormItemProperties<T>
}

export const ProfilePictureFormCoverImage = <T extends object>({
    profilePictureFile, profilePictureUrl, onProfilePictureChange, submitting, formItemProperties
}: ProfilePictureFormCoverImageProps<T>) => {

    const theme = useTheme();
    const hasFile = profilePictureFile !== undefined;
    const width = 250;
    const formattedStyle: React.CSSProperties = {
        width,
        border: formItemProperties.showFeedback ?
            (formItemProperties.valid ? `2px solid ${theme.palette.success.main}` : `2px solid ${theme.palette.error.main}`) :
            '1px solid rgb(200,200,200)'
    }
    const showError = formItemProperties.showFeedback && formItemProperties.errorMessage;

    return (
        <Box sx={{
            display: 'flex',
            paddingBottom: '10px',
            flexDirection: 'column',
            justifyItems: 'center',
            width: '250px',
            margin: '0 auto'
        }}
        >
            <Box sx={{ paddingTop: 4 }}>
                {hasFile &&
                    <img src={profilePictureFile as unknown as string} alt="profile picture" style={formattedStyle} />
                }
                {!hasFile && profilePictureUrl &&
                    <img src={profilePictureUrl} alt="hero cover" style={formattedStyle} />
                }
                {!hasFile && !profilePictureUrl &&
                    <Box style={{
                        height: 311,
                        border: "1px solid rgb(200,200,200)",
                        borderRadius: 2,
                        textAlign: "center",
                        paddingTop: 100,
                        color: "rgb(100,100,100)",
                        margin: '0 auto',
                        ...formattedStyle
                    }}>
                        <Box><Image style={{ fontSize: 60 }} /></Box>
                        <Box style={{ paddingTop: 10 }}>Upload a profile picture</Box>
                    </Box>
                }
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: showError ? 'space-between' : 'flex-end',
                    marginTop: '10px'
                }}
            >
                {showError &&
                    <Box sx={{ height: '40px' }}>
                        <Typography sx={{ color: theme.palette.error.main, fontSize: '14px' }}>
                            {formItemProperties.errorMessage}
                        </Typography>
                    </Box>
                }
                <Box>
                    <ModalImageCropper
                        onCroppedImage={onProfilePictureChange}
                        aspectRatio={4 / 5}
                        disabled={submitting}
                    />
                </Box>
            </Box>
        </Box>
    )
}
